/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { CanActivateFn, Router } from '@angular/router';
import { TokenStatus } from '../enums';
import { UserService } from '../services';
import { inject } from '@angular/core';

export const HasOrgIdGuard: CanActivateFn = (): boolean => {
    const userService: UserService = inject(UserService);
    const router: Router = inject(Router);

    if ((userService.tokenStatus() === TokenStatus.OK) && !userService.getUser('organisationId')) {
        router.navigateByUrl('/cm/onboard').then().catch();

        return false;
    }

    return true;
};
